// extracted by mini-css-extract-plugin
export default {"emptyState":"CommonEmptyStateUI_emptyState__8U7ny"};